import React from 'react';
import ExpandablePanel from '@Components/UI/ExpandablePanel/ExpandablePanel';
import { FilterWrapper } from './ScoreCardFilters.style';
import {
    QuickFilter,
    TopicsFilter,
    SubTopicsFilter,
    AnswersFilter,
    ExtractionsFilter,
    ClausesFilter,
    Sorting
} from './components';

const ScoreCardFilters = () => (
    <FilterWrapper>
        <QuickFilter />
        <ExpandablePanel testid="scorecards_filter_menu_arrow_button">
            <TopicsFilter />
            <SubTopicsFilter />
            <AnswersFilter />
            <ExtractionsFilter />
            <ClausesFilter />
            <Sorting />
        </ExpandablePanel>
    </FilterWrapper>
);

export default React.memo(ScoreCardFilters);
